import { axiosInstance } from "lib/axios";
import { authAPI, searchAPI } from "services/apis.service";

export const getrecentCollections = async (user) => {
  const { data } = await axiosInstance.post(
    searchAPI.getRecentCollections,
    {
    },
    {
      cache: false,
    }
  );
  return data;
};

export const getrecentCollectionSource = async (user, filter, signal) => {
  const { data } = await axiosInstance.post(
    searchAPI.getCollectionsSource,
    {
      filter: filter,
      forBookmarkPanel: true,
      // pageSize: 25,
    },
    {
      cache: false,
      signal: signal,
    }
  );
  return data;
};
